import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { Store } from "@ngrx/store";
import { selectToken } from "@state/selectors/user.selectors";
import { HttpService } from "./http.service";
import { Servico, SugestoesPorCnae } from "@interfaces/service";
import { tap } from "rxjs";
import { UserActions } from "@state/actions/user.actions";

@Injectable({
  providedIn: "root"
})
export class NfseServiceService {
  url = `${environment.api.mv.nf}/nfse-service`;
  // userId = this.store.selectSignal(selectUserId);
  token = this.store.selectSignal(selectToken);

  constructor(
    private readonly httpService: HttpService,
    private readonly store: Store
  ) {}

  getServices(page = 1, limit = 6) {
    return this.httpService.get<{
      data: Servico[];
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    }>(`${this.url}?&page=${page}&limit=${limit}`);
  }

  /**
   * Itens da LC 116 sugeridos para o CNAE (tabela do nf-server, a mesma do
   * pré-cadastro pela consulta de CNPJ). Primeiro elo da cadeia
   * CNAE → item da LC 116 → NBS → CST/classificação tributária.
   */
  fetchSugestoesPorCnae(cnae: string) {
    const digits = (cnae ?? "").toString().replace(/\D/g, "");

    return this.httpService.get<SugestoesPorCnae>(
      `${this.url}/sugestoes/${digits}`
    );
  }

  save(body: object) {
    return this.httpService.post(this.url, body).pipe(
      tap(() =>
        this.store.dispatch(
          UserActions.loadToken({
            token: this.token()
          })
        )
      )
    );
  }

  /**
   * Ativa/inativa o serviço. Só serviços ativos entram na emissão; ativar
   * exige a parametrização mínima (o nf-server valida).
   */
  setAtivo(id: string, ativo: boolean) {
    return this.httpService.patch<Servico>(`${this.url}/${id}/ativo`, {
      ativo
    });
  }

  update(id: string, body: object) {
    return this.httpService
      .patch(`${this.url}/${id}`, {
        ...body
      })
      .pipe(
        tap(() =>
          this.store.dispatch(
            UserActions.loadToken({
              token: this.token()
            })
          )
        )
      );
  }

  deleteService(id: string) {
    return this.httpService.del(`${this.url}/${id}`).pipe(
      tap(() =>
        this.store.dispatch(
          UserActions.loadToken({
            token: this.token()
          })
        )
      )
    );
  }
}
